module.exports = __webpack_public_path__ + "static/media/hxtz.c470eb3a.svg";